import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Categories from "./components/Categories";
import HotSection from "./components/HotSection";
import Gallery from "./components/Gallery";
import Danmaku from "./components/Danmaku";
import Story from "./components/Story";
import Faq from "./components/Faq";
import Subscribe from "./components/Subscribe";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <Categories />
        <HotSection />
        <Gallery />
        <Danmaku />
        <Story />
        <Faq />
        <Subscribe />
      </main>
      <Footer />
    </div>
  );
}